import { VBtn } from "vuetify/lib";

export default {
	name: "KNotFound",

	computed: {
		dense() {
			return this.$vuetify.breakpoint.smAndDown;
		}
	},

	render() {
		return <div class="text-center">
			<h1 class={{
				"text-h3": this.dense,
				"text-h1": !this.dense
			}}>Uh oh! Sorry about that.</h1>

			<h2 class={{
				"mt-3": true,
				"text-subtitle-1": this.dense,
				"text-h4": !this.dense
			}}>The page could not be found or you don't have permission to view it.</h2>

			<h4 class={{
				"mt-3": true,
				"text-caption": this.dense,
				"text-subtitle-1": !this.dense
			}}>(Error: 404)</h4>

			<VBtn
				class="my-5"
				exact
				to={{ name: "front" }}
			>Return to Home Page</VBtn>
		</div>;
	}
};
